// @todo fix view paths
// Require Template
import baseTemplate from './customfield.tpl.html';
import moment from 'moment';
import './ace.tpl.html';
import './array.tpl.html';
import './boolean.tpl.html';
import './builder.tpl.html';
import './date.tpl.html';
import './datetime.tpl.html';
import './datetimeexact.tpl.html';
import './decimal.tpl.html';
import './enum-color-array.tpl.html';
import './color_code_select.tpl.html';
import './field.tpl.html';
import './file.tpl.html';
import './image.tpl.html';
import './integer.tpl.html';
import './number.tpl.html';
import './select.tpl.html';
import './select-box.tpl.html';
import './textarea.tpl.html';
import './color-picker.tpl.html';
import './textbox.tpl.html';
import './password.tpl.html';
import './media_image.tpl.html';
import './media_file.tpl.html';
import './html.tpl.html';
import './time.tpl.html';
import './multi_select.tpl.html';


/**
 * @ngdoc directive
 */
angular
    .module('festzelt-os.components')
    .directive('customfield', [
        function () {
            return {
                restrict: 'E',
                require: 'ngModel',
                bindToController: {
                    'ngModel': '=',
                    'definition': '=',
                    'name': '@'
                },
                scope: {
                    'ngModel': '=',
                    'definition': '=',
                    'name': '@'
                },
                link: function (scope, element, attrs, ngModelController) {

                    scope.onChange = function () {
                        ngModelController.$setViewValue(scope.ngModel);
                    };

                    //set default value if null
                    ngModelController.$render = function () {
                        scope.ngModel = ngModelController.$modelValue;
                        if (_.isUndefined(scope.ngModel) && !_.isUndefined(scope.definition.default)) {
                            scope.ngModel = scope.definition.default;
                        }
                    };

                },
                controller: CustomFieldDirectiveController,
                controllerAs: 'field',
                templateUrl: baseTemplate
            }
        }
    ]);


class CustomFieldDirectiveController {

    constructor($scope, $timeout) {
        this.scope = $scope;
        this.timeout = $timeout;
        this.lodash = _;
        this.customIdentifier = 'custom-field-' + Math.floor(Math.random() * 1000) + 1;

        this.selectizeOptions = null;
        this.definition = {};

        this._initWatchers()
    }

    setModelToNull() {
        this.momentModel = null;
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.ngModel
        }, (current, previous) => {
            if (this.definition) {
                if (this.definition.type === 'date' || this.definition.type === 'datetime') {
                    if (_.isUndefined(this.momentModel) && !_.isNull(this.ngModel)) {
                        this.momentModel = _.cloneDeep(this.ngModel);
                    }
                }

                if (this.definition.onChange) {
                    this.definition.onChange(current, previous, this.scope.$parent.ngModel, this.scope.$parent.$parent.$index);
                }
            }
        });

        this.scope.$watch(() => {
            return this.ngModel ? this.ngModel.type : undefined
        }, () => {
            if (this.definition && this.definition.type === 'builder') {
                if (!this.ngModel || this.ngModel.length === 0) {
                    this.ngModel = {};
                }

                if (this.ngModel && (this.ngModel.type === 'select' || this.ngModel.type === 'multi_select')) {
                    this.ngModel.enum = this.ngModel.enum ? this.ngModel.enum : [];
                }
            }
        });

        this.scope.$watch(() => {
            return this.definition;
        }, (newVal, oldVal) => {
            if (
                !_.isEqual(_.get(newVal, 'enum', []), _.get(oldVal, 'enum', []))
                || !_.isEqual(_.get(newVal, 'options', {}), _.get(oldVal, 'options', {}))
                || _.isNull(this.selectizeOptions)
            ) {
                this._prepareSelectizeOptions()
            }
        }, true);
    }

    momentPickerChange(newValue, oldValue) {
        if (_.isUndefined(newValue) || !newValue) {
            this.ngModel = null;
        } else {
            switch (this.definition.type) {
                case 'date':
                    this.ngModel = moment(newValue).format('YYYY-MM-DD');
                    break;
                case 'datetime':
                    this.ngModel = moment(newValue).format();
                    break;
                default:
                    this.ngModel = newValue;
            }
        }
    }

    updateModelValue(newValue) {
        this.ngModel = newValue;
    }

    updateFileModel(file) {
        if (_.isObject(file)) {
            this.ngModel = _.get(file, 'uuid', null);
        } else {
            this.ngModel = null;
        }
        this.scope.$applyAsync();
    }

    moveUp(index) {
        this.arraymove(this.ngModel, index, index - 1);
    }

    moveDown(index) {
        this.arraymove(this.ngModel, index, index + 1);
    }

    arraymove(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
    }

    _prepareSelectizeOptions() {
        const definitionOptions = _.get(this.definition, 'options', {}),
            definitionEnum = _.get(this.definition, 'enum', []);

        if (_.isObject(definitionOptions) && !_.isEmpty(definitionOptions)) {
            this.selectizeOptions = _.map(definitionOptions, (value, key) => {
                return {
                    value: key,
                    label: value
                }
            })
            return;
        }

        if (_.isArray(definitionEnum) && !_.isEmpty(definitionEnum)) {
            this.selectizeOptions = _.map(definitionEnum, (value) => {
                return {
                    value: value,
                    label: value
                }
            })
        }
    }

}

CustomFieldDirectiveController.$inject = [
    '$scope',
    '$timeout'
];



// WEBPACK FOOTER //
// ./src/app/components/directives/customfield/customfield-directive.js